<section class="callback-page">
    <mat-card class="callback-card">
        <mat-card-content>
            <h1 class="title">Authentication</h1>
            <p class="hint">{{ posted() ? 'You can close this window.' : 'Finalizing authentication…' }}</p>
        </mat-card-content>
    </mat-card>
</section>

